// W10-3 — CARDS RENDER AS CARDS IN CHAT. Props in, tree out, no state and no hook, so
// `scripts/w10-card-pull.mjs` CALLS this and reads the tree back rather than matching its source.
//
// HER RULE: "NEVER 'card 1: The High Priestess' as bare text." A card Lala names in a reading is a
// PICTURE in the conversation, on the page and in the drawer, on the phone and on the desktop. It goes
// through `TarotCardImage` — N4-1's one card image — so the reversal rule lives in exactly one place
// and a new surface cannot forget it. That is the whole reason this component is three lines of
// layout around someone else's img: the rotation is not ours to re-implement.

import { TarotCardImage } from "./TarotCardImage";

export type ChatCard = { slug: string; name: string; position?: string; orientation?: string };

export function ChatCards({ cards }: { cards: ChatCard[] }) {
  if (!cards?.length) return null;
  return (
    <div className="chat-cards" aria-label="The cards Lala pulled">
      {cards.map((c, i) => (
        <figure className="chat-cards__card" key={`${c.slug}-${i}`}>
          <TarotCardImage slug={c.slug} name={c.name} orientation={c.orientation} className="chat-cards__img" loading="lazy" />
          <figcaption className="chat-cards__cap">
            {c.position ? <span className="chat-cards__pos">{c.position}</span> : null}
            <span className="chat-cards__name">{c.name}</span>
            {/* The word is only ever printed when the picture is ALSO upside down, because the two
                disagreeing is the exact defect N4-1 exists to prevent. */}
            {c.orientation === "reversed" ? <span className="chat-cards__rev">reversed</span> : null}
          </figcaption>
        </figure>
      ))}
    </div>
  );
}
